import { CardCombinedProps } from './types';

const usePresenter = (props: CardCombinedProps): CardCombinedProps => {
  return props;
};

export default usePresenter;
